import { render } from "./ModalFaq.vue?vue&type=template&id=7a1cfb71&scoped=true"
import script from "./ModalFaq.vue?vue&type=script&lang=js"
export * from "./ModalFaq.vue?vue&type=script&lang=js"

import "./ModalFaq.vue?vue&type=style&index=0&id=7a1cfb71&scoped=true&lang=css"

import exportComponent from "/Users/yao/Documents/projects/garden/garden_ts/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a1cfb71"]])

export default __exports__